// extracted by mini-css-extract-plugin
export default {"choise":"References_choise__4qWn0","active":"References_active__pNi5N","sjaUpload":"References_sjaUpload__DjCDf","reference":"References_reference__-c9Tp"};